import PropTypes from "prop-types";

import styled from "styled-components/macro";

import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";

import FnrButton, { ButtonText } from "UI/FnrButton3";

import { formatUSD, getDecimal } from "./helpers";

export default function AddGiftButton({
  amount,
  addOnGift,
  onClick,
  onMouseEnter,
  onMouseLeave,
}) {
  const {
    state: {
      fund: { fundColorSafe },
      amount: donationAmount,
    },
  } = usePaymentPage();
  const { type, percentage } = addOnGift;

  return (
    <>
      <Button onClick={onClick} color={fundColorSafe || "blue"} stopPropagation>
        <BtnText>
          Add{" "}
          {type === "percentage" && !donationAmount ? (
            <>{Math.round(percentage * 100 * 100) / 100}%</>
          ) : (
            <Amount>
              <Dollar>
                {amount > 0
                  ? `$${parseInt(Math.round(amount * 100) / 100)}`
                  : ""}
              </Dollar>
              <Decimal>{getDecimal(amount)}</Decimal>
            </Amount>
          )}
        </BtnText>
      </Button>
    </>
  );
}

AddGiftButton.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  addOnGift: PropTypes.object,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
};

const Wrapper = styled.div``;

const Button = styled(FnrButton)`
  //min-width: 125px;
  //max-width: 125px;

  .FnrButtonContent {
    padding: 6px 10px;
  }

  @media screen and (max-width: 460px) {
    min-width: 94px;
  }
`;

const BtnText = styled(ButtonText)`
  white-space: nowrap;
  font-size: 16px;
  display: flex;
  align-items: flex-start;
  gap: 4px;
`;

const Amount = styled.div`
  display: flex;
  align-items: flex-start;
`;

const Dollar = styled.span``;

const Decimal = styled.span`
  //vertical-align: super;
  font-size: 12px;
  line-height: 18px;
`;
